import { Navigate } from 'react-router-dom'
import { useAuth } from '@hooks/useAuth'

interface ProtectedRouteProps {
  adminOnly?: boolean
  children: React.ReactNode
}

function ProtectedRoute({ adminOnly = false, children }: ProtectedRouteProps) {
  const { isAdmin } = useAuth()

  if (adminOnly && !isAdmin) {
    return <Navigate to='/' replace />
  }

  return <>{children}</>
}

export default ProtectedRoute
